import { useState } from 'react';
import ApiClient from '../services/apiClient';

/**
 * Hook personalizado para manejar la descarga de archivos
 * 
 * @param {string} mediaUrl - URL del archivo
 * @param {string} defaultExtension - Extensión predeterminada (.jpg, .mp4, etc.)
 * @param {string} defaultName - Nombre predeterminado si no hay caption
 * @param {string} caption - Texto descriptivo opcional para usar como nombre de archivo
 * @returns {Object} - Estado de descarga y función handler
 */
const useDownloadHandler = (mediaUrl, defaultExtension = '.jpg', defaultName = 'archivo', caption = '') => {
    const [isDownloading, setIsDownloading] = useState(false);
    
    const handleDownload = (event) => {
        // Detener la propagación para evitar que abra el modal si se llama en un elemento clickeable
        if (event) {
            event.stopPropagation();
        }
        
        // Marcar que se está descargando
        setIsDownloading(true);
        
        try {
            // Obtener un nombre personalizado o usar uno genérico
            const fileName = caption 
                ? `${caption.substring(0, 30)}${defaultExtension}` 
                : `${defaultName}${defaultExtension}`;
            
            // Usar el método que maneja la autenticación, con callbacks
            ApiClient.initiateSecureDownload(
                mediaUrl,
                fileName,
                // Callback de éxito
                () => {
                    setIsDownloading(false);
                },
                // Callback de error
                (error) => {
                    console.error(`Error al descargar ${defaultName}:`, error);
                    setIsDownloading(false);
                }
            );
        } catch (error) {
            console.error(`Error al preparar la descarga de ${defaultName}:`, error);
            setIsDownloading(false);
        }
    };
    
    return {
        isDownloading,
        handleDownload
    };
};

export default useDownloadHandler;